
import { useState, useEffect } from "react";

import styled from "styled-components";
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

import { socket } from "../Chat/socket.js";
import Chat from '../Chat/Chat.js';
import axios from 'axios'
import { useUploadAnexo } from "./../components/UploadAnexo.js";
import Swal from "sweetalert2";
import { ImBin } from "react-icons/im";
import { toast } from 'react-toastify';
import OrangeButton from "../../../../ui/OrangeButton.js";

const Tr2 = styled.tr`
  display: flex; 
  justify-content: space-between;
  text-align: center;


 
`;
export const Td = styled.td`
  font-size: 18px;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  color: #3a3f42;
  width: auto;
  text-align: start;
`;

const Table = styled.table`
  width: auto;
  background-color: transparent;
  padding: 5px 5px;

`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`

`;





const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;

`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;
    margin-top: 1rem;
  select {
    &.erro {
      border: 2px solid red;
      
    }
  }

  input{
    border-radius: 6px;
    padding: 0px 10px;
    height: 35px;
    width: 200px;
    font-weight: normal;

    border: 0.1px solid #ccc;
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;

const H2 = styled.h2`
  color: #575757;
`;




const SelectContainer = styled.div`


  .custom-select__control {
    border-radius: 6px;
    padding: 2px 0px;
    height: 35px;
    width: 700px;
    box-shadow: none;
    font-weight: normal;
    &:hover {
      border-color: #888;
    }
    &.erro {
      border: 2px solid red;
    
    }
  }

  .custom-select__menu {
    z-index: 9999; /* Isso garante que fique acima do modal */
  }

  .custom-select__menu-list {
    max-height: 120px; /* ~3 itens */
    overflow-y: auto;
  }

  .custom-select__option {
    padding: 2px 0px;
    color: #575757;
    background-color: #fff;
    font-weight: normal;
  }

  .custom-select__placeholder {
    color: #999;
    font-weight: normal;
  }

  .custom-select__single-value {
    color: #000;
    font-weight: normal;
  }

  .custom-select__control.erro {
    border: 2px solid red;
  }


  select {
    width: 700px;
  }
`;


const TextAreaContainer = styled.div`
  margin-top: 8px;
  width: 700px;

    &.erro {
      border: 2px solid red;
      
    }
`;

const TextAreaStyled = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  resize: vertical;
  background-color: #f9f9f9;
  color: #333;
  font-family: inherit;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007bff;
    background-color: #fff;
  }

  &.erro {
      border: 2px solid red;
      
    }
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
const Div2 = styled.div`
  width: 95%;
  display: flex; 
  padding: 0px;
  gap: 10px 0px;
  flex-direction: column;
  margin-top: 30px;
`;




const Form = ({ listaEquipamento, urlApi, usuarioEquipamento, tipoChamado, subTipoChamado, itemSubTipoChamado, verChamado, setIsModalOpenVerChamado, modalApontamentos, setIsModalOpenFinalizarChamado, tipoAcessoModulo8 }) => {
  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');



  useEffect(() => {
    if (verChamado) {
      setUsuarioEquipamentoSelecionado(verChamado.COD_FUNCIONARIO_SOLICITANTE);
      setTipoSelecionado(verChamado.COD_TIPOCHAMADO);
      setSubTipoChamadoSelecionado(verChamado.COD_SUBTIPOCHAMADO);
      setItemSubTipoChamadoSelecionado(verChamado.COD_ITEMSUBTIPOCHAMADO);
      setDescricaoChamado(verChamado.DESC_PROBLEMA);


      setSituacaoSelecionada(verChamado.COD_SITUACAO || '');
      setPrioridadeSelecionada(verChamado.COD_PRIORIDADE || '');
      setTipoAtendimentoSelecionado(verChamado.COD_TIPOATENDIMENTO || '');

      setDescricaoAdmin(verChamado.DESC_ADMIN || '');

    }
  }, [verChamado]);




  const [tipoSelecionado, setTipoSelecionado] = useState('');
  const [subTipoChamadoSelecionado, setSubTipoChamadoSelecionado] = useState('');
  const [itemSubTipoChamadoSelecionado, setItemSubTipoChamadoSelecionado] = useState('');
  const [descricaoChamado, setDescricaoChamado] = useState('');
  const [usuarioEquipamentoSelecionado, setUsuarioEquipamentoSelecionado] = useState("");

  const [situacaoSelecionada, setSituacaoSelecionada] = useState('');
  const [prioridadeSelecionada, setPrioridadeSelecionada] = useState('');
  const [tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado] = useState('');

  const [descricaoAdmin, setDescricaoAdmin] = useState('');

  //Usuários do SELECT
  const opcoesUsuarios = usuarioEquipamento.map((tipo) => ({
    value: tipo.Cod_Func,
    label: `${tipo.Cod_Func} - ${tipo.Desc_Func} - ${tipo.Desc_Departamento}`,
  }));










  const handleAtenderChamado = () => {
    setIsModalOpenVerChamado(false);
    setIsModalOpenFinalizarChamado(true);
  };



  socket.on("connect", () => {
    // console.log("🟢 Socket conectado: ", socket.id);
  });


  const [anexos, setAnexos] = useState([]);

  const fetchAnexos = async () => {
    if (!verChamado?.ID_CHAMADO) return;

    try {
      const res = await axios.get(
        `${urlApi}central-ti/anexos?id_chamado=${verChamado.ID_CHAMADO}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAnexos(res.data);
    } catch (error) {
      console.error("Erro ao buscar anexos do chamado:", error);
    }
  };

  useEffect(() => {
    if (verChamado?.ID_CHAMADO) {
      fetchAnexos();
    }
  }, [verChamado]);






  const downloadArquivo = async (nomeSalvo) => {
    try {
      const response = await axios.get(`${urlApi}central-ti/download/${nomeSalvo}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeSalvo);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Erro ao baixar anexo:", error);
    }
  };




  const [tagSelecionada, setTagSelecionada] = useState(verChamado.TAG_EQUIPAMENTO);
  console.log(tagSelecionada)

  const regrasFiltroTipoEquipamento = {
    181: [1],        // subTipo 181 → mostrar apenas equipamentos tipo 2
    182: [2],     // subTipo 182 → tipo 1 ou 3
    183: [3],
    183: [7],
  };










  const opcoesEquipamentos = listaEquipamento.map(equip => ({
    value: equip.TAG_EQUIPAMENTO,
    label: equip.TAG_EQUIPAMENTO,
    equipamento: equip
  }));




  const handleApontar = () => {
    modalApontamentos();
  };






  return (
    <DivGeral>
      <H2>Dados do chamado cancelado:</H2>


      <Div>
        <Label>
          N° Chamado:
          <input
            type="text"
            value={verChamado?.ID_CHAMADO || ''}
            disabled
          />
        </Label>

        <Label>
          Situação:
          <input
            type="text"
            value={verChamado?.DESC_SITUACAO || ''}
            disabled
          />
        </Label>


      </Div>
      <Div>

        <Label>
          Data Criação:
          <input
            type="text"
            value={verChamado?.DATA_FORMATADA || ''}
            disabled
          />
        </Label>
        <Label>
          Capturado:
          <input
            type="text"
            value={verChamado?.DATA_FORMATADA2 || ''}
            disabled
          />
        </Label>
        <Label>
          Finalizado:
          <input
            type="text"
            value={verChamado?.DATA_FORMATADA3 || ''}
            disabled
          />
        </Label>



      </Div>

      <Div>
        <Label>
          Usuário solicitante:
          <SelectContainer>
            <Select
              classNamePrefix="custom-select"
              options={opcoesUsuarios}
              value={opcoesUsuarios.find(opt => opt.value === usuarioEquipamentoSelecionado)}

              onChange={(selected) => {
                const codFunc = selected?.value || '';
                setUsuarioEquipamentoSelecionado(codFunc);


              }}
              disabled
              isClearable

            />


          </SelectContainer>
        </Label>

      </Div>
      <Div>
        <Label>
          Tipo de chamado:
          <SelectContainer>
            <select

              value={tipoSelecionado}

              disabled
            >

              {tipoChamado.map((tipo) => (
                <option key={tipo.COD_TIPOCHAMADO} value={tipo.COD_TIPOCHAMADO}>
                  {tipo.DESC_TIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>
        </Label>

      </Div>

      <Div>
        <Label>
          Assunto do chamado:
          <SelectContainer>
            <select
              value={subTipoChamadoSelecionado}

              disabled

            >

              {subTipoChamado.map((i) => (
                <option key={i.COD_SUBTIPOCHAMADO} value={i.COD_SUBTIPOCHAMADO}>
                  {i.DESC_SUBTIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>


        </Label>


      </Div>

      <Div>
        <Label>
          Detalhamento do chamado:
          <SelectContainer>
            <select
              value={itemSubTipoChamadoSelecionado}
              onChange={(e) => setItemSubTipoChamadoSelecionado(e.target.value)}
              disabled
            >
              {itemSubTipoChamado.map((i) => (
                <option key={i.COD_ITEMSUBTIPOCHAMADO} value={i.COD_ITEMSUBTIPOCHAMADO}>
                  {i.DESC_ITEMSUBTIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>


        </Label>


      </Div>

      <Div>
        <Label>
          Equipamento selecionado:
          <SelectContainer>
            <Select
              classNamePrefix="custom-select"
              options={opcoesEquipamentos}
              value={opcoesEquipamentos.find(opt => opt.value === tagSelecionada)}
              onChange={(selected) => {
                const tag = selected?.value || '';
                setTagSelecionada(tag);

                const equipamentoSelecionado = listaEquipamento.find(e => e.TAG_EQUIPAMENTO === tag);

              }}

              placeholder="Nenhum equipamento selecionado"
              isClearable
              isDisabled
              formatOptionLabel={(option, { context }) => {


                return (
                  <div style={{ display: 'flex' }}>
                    <small style={{ color: '#888' }}>
                      <strong>{option.value}</strong> - {option.equipamento?.DESC_TIPO_EQUIPAMENTO} • {option.equipamento?.DESC_MARCA_MODELO} • {option.equipamento?.DESC_DEPARTAMENTO} • {option.equipamento?.DESC_SITUACAO}
                    </small>
                  </div>
                );
              }}
            />



          </SelectContainer>
        </Label>
      </Div>
      <Div>
        <Label>
          Detalhadamente o problema:
          <TextAreaContainer>
            <TextAreaStyled
              disabled
              value={descricaoChamado}
              onChange={(e) => setDescricaoChamado(e.target.value)}
            />
          </TextAreaContainer>
        </Label>

      </Div>
      <Div>
        <Label style={{ marginTop: '50px' }}>
          Administrador atendeu:
          <input
            type="text"
            value={`${verChamado?.COD_ADMIN_ATENDEU} - ${verChamado?.Desc_AdminAtendeu}` || ''}
            disabled
            style={{ width: '680px' }}
          />
        </Label>
      </Div>
      <Div>
        <Label >
          Administrador finalizou:
          <input
            type="text"
            value={`${verChamado?.COD_ADMIN_FINALIZOU} - ${verChamado?.Desc_AdminFinalizou}` || ''}
            disabled
            style={{ width: '680px' }}
          />
        </Label>
      </Div>
      <Div>

        <Label >
          Situação:
          <SelectContainer>
            <select
              value={situacaoSelecionada}
              onChange={(e) => setSituacaoSelecionada(e.target.value)}
              disabled
            >
              <option value="AT">Atendimento</option>

            </select>

          </SelectContainer>
        </Label>
      </Div>
      <Div>
        <Label>
          Prioridade:
          <SelectContainer>
            <select
              value={prioridadeSelecionada}
              onChange={(e) => setPrioridadeSelecionada(e.target.value)}
              disabled
            >
              <option value="">Escolha uma opção</option>
              <option value="A">Alta</option>
              <option value="M">Média</option>
              <option value="B">Baixa</option>
            </select>
          </SelectContainer>
        </Label>
      </Div>
      <Div>
        <Label>
          Tipo de atendimento:
          <SelectContainer>
            <select
              value={tipoAtendimentoSelecionado}
              onChange={(e) => setTipoAtendimentoSelecionado(e.target.value)}
              disabled
            >
              <option value="">Escolha uma opção</option>
              <option value="PR">Presencial</option>
              <option value="RE">Remoto</option>
            </select>

          </SelectContainer>
        </Label>
      </Div>

      <Div>
        <Label>
          Detalhadamento do administrador:
          <TextAreaContainer>
            <TextAreaStyled
              disabled
              value={descricaoAdmin}
              onChange={(e) => setDescricaoAdmin(e.target.value)}
            />
          </TextAreaContainer>
        </Label>

      </Div>


      <Div style={{ marginTop: '40px', display: 'flex', flexDirection: 'column' }}>
        <Label>Chat do Chamado:


        </Label>
        <Chat
          socket={socket}
          logon={id}
          urlApi={urlApi}
          onEdit={verChamado}
          readOnly={true}
        />

      </Div>


      <Div2>
        <Label>Arquivos anexados:</Label>

        <div style={{ marginBottom: "16px" }}>
          {anexos.length > 0 ? (
            <Table style={{ width: "100%", borderCollapse: "collapse" }}>
              <Tbody>
                {anexos.map((anexo) => (
                  <Tr2 key={anexo.ID_ANEXO}>
                    <Td style={{ padding: "8px 16px", textAlign: "left", whiteSpace: "nowrap" }}>
                      <span
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadArquivo(anexo.NOME_SALVO)}
                      >
                        {anexo.NOME_ORIGINAL}
                      </span>
                    </Td>
                    <Td
                      style={{
                        padding: "8px 16px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        color: "#333",
                      }}
                    >
                      {anexo.DATA_CRIACAO}
                    </Td>

                  </Tr2>
                ))}
              </Tbody>
            </Table>
          ) : (
            <p style={{ color: "#888" }}>Nenhum arquivo anexado.</p>
          )}
        </div>
      </Div2>
      <Div>
        {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
          <OrangeButton onClick={handleApontar}>
            Apontamentos
          </OrangeButton>
        )}
      </Div>


      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




